export interface FinancePlan {
  label: string
  rate: number // Decimal, e.g., 0.091 for 9.10%
}

export interface FinanceCompanyConfig {
  name: string
  plans: FinancePlan[]
  noFee?: boolean // If true, dealer fee is always 0%
  customRate?: boolean // If true, user enters a custom rate
}

export const FINANCE_COMPANIES: FinanceCompanyConfig[] = [
  {
    name: 'Synchrony',
    plans: [
      { label: 'Plan 924 — 0% Interest, 18 Mo (9.10% fee)', rate: 0.091 },
      { label: 'Plan 942 — 7.99% Interest, 115 Mo (12.75% fee)', rate: 0.1275 },
      { label: 'Plan 960 — 3.99% Interest, 64 Mo (17.25% fee)', rate: 0.1725 },
      { label: 'Plan 931 — 0% Interest, 36 Mo (17.45% fee)', rate: 0.1745 },
      { label: 'Plan 933 — 0% Interest, 60 Mo (21.70% fee)', rate: 0.217 },
    ],
  },
  {
    name: 'Hearth',
    noFee: true,
    plans: [],
  },
  {
    name: 'GreenSky',
    customRate: true,
    plans: [],
  },
]

export function getCompanyConfig(
  name: string,
): FinanceCompanyConfig | undefined {
  return FINANCE_COMPANIES.find((c) => c.name === name)
}
